import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import Enter from '../views/Enter.vue'
import SiteMap from '../views/SiteMap.vue'

import AwardHome from '../views/Awards/Home.vue'
import AwardWinners from '../views/Awards/AwardWinners.vue'

import FestivalHome from '../views/Festival/Home.vue'

import Category from '../views/Category.vue'
import Post from '../views/Post.vue'

Vue.use(VueRouter)

const categoryLangMap = {
  zh_tw: {
    152: 62,
    134: 68,
    113: 59,
    114: 130,
    116: 52
  },
  en: {
    62: 152,
    68: 134,
    59: 113,
    130: 114,
    52: 116
  }
}

const postLangMap = {
  zh_tw: {
    397: 285
  },
  en: {
    285: 397
  }
}

function getSiteLang() {
  return VueCookies.isKey('gma_the_site_lang') ? VueCookies.get('gma_the_site_lang') : 'zh_tw'
}

function getLangMap(map) {
  return getSiteLang() === 'zh_tw' ? map.zh_tw : map.en
}

const routes = [
  {
    path: '/',
    name: 'Enter',
    component: Enter
  },
  {
    path: '/SiteMap',
    name: 'SiteMap',
    component: SiteMap
  },
  {
    path: '/Awards/',
    name: 'AwardHome',
    component: AwardHome
  },
  {
    path: '/Awards/AwardWinners',
    name: 'AwardWinners',
    component: AwardWinners
  },

  {
    path: '/Festival/',
    name: 'FestivalHome',
    component: FestivalHome
  },
  
  {
    path: '/Category/:CId',
    name: 'Category',
    component: Category
  },
  {
    path: '/Post/:PId/:CId?',
    name: 'Post',
    component: Post
  },
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Category') {
    const categoryMap = getLangMap(categoryLangMap)
    const targetCId = categoryMap[to.params.CId]

    if (targetCId) {
      next({
        name: to.name,
        params: { ...to.params, CId: targetCId },
        query: to.query,
        hash: to.hash,
        replace: true
      })
      return
    }
  }

  if (to.name === 'Post') {
    const postMap = getLangMap(postLangMap)
    const targetPId = postMap[to.params.PId]

    if (targetPId) {
      next({
        name: to.name,
        params: { ...to.params, PId: targetPId },
        query: to.query,
        hash: to.hash,
        replace: true
      })
      return
    }
  }

  next()
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

export default router
